/**
 * Form // Formの定義
 *
 * @returns {undefined}
 */

class Form {
  /**
   * call // 定数定義に沿ってAPIを呼び出す
   *
   * @param {string} name // APIのURLの名前
   * @param {object} obj // 送るデータのオブジェクト
   * @param {function} callback // 成功後に実行するコールバック
   *
   * @return promise
   */
  call(method, url, obj = {}) {
    if (method === 'get') this.get(url, obj)
  }

  /**
   * post // formでポストする
   *
   * @param {string} url // url
   * @param {object} data // 投げるデータ
   */
  get(url, data) {
    console.log('Form.post', data)
    const form = document.createElement('form')
    form.setAttribute('action', url)
    form.setAttribute('method', 'get')
    form.setAttribute('target', '_blank')
    form.setAttribute('rel', 'noopener nofollow')
    form.style.display = 'none'

    // パラメタの設定
    if (data !== null) {
      for (const paramName in data) {
        if (data[paramName] !== 'none' && data[paramName] !== null) {
          const input = document.createElement('input')
          input.setAttribute('type', 'hidden')
          input.setAttribute('name', paramName)
          input.setAttribute('value', data[paramName])
          form.appendChild(input)
        }
      }
      document.body.appendChild(form)
      form.submit()
    }
  }
}

export default new Form()
